export const CRITIQUES = [
  {
    id: "crit-001",
    source: "Avis lecteur",
    auteur: "Compagnie Littéraire",
    date: "2025-03-08",
    extrait:
      "Les avis qu’on peut lire sont nettement positifs, centrés sur l’humour, le charme provençal, la dynamique des personnages et la facilité de lecture. L’ambiance que décrivent les premiers retours ressemble à une suite de petites lettres ou scènes amusantes, qui s’accrochent aux odeurs, aux paysages et aux voix des protagonistes, plutôt qu’à une intrigue lourde ou dramatique.",
    tags: ["Émotion", "Poétique"],
  },
  {
    id: "crit-002",
    source: "Avis lecteur",
    auteur: "Samuel AUGUSTO",
    date: "2025-12-05",
    extrait:
      "J’ai pris le temps de m’installer avec ton livre comme on s’installe face à la mer, en silence, dans l’écoute. Ton livre m’a fait rire – souvent à voix haute – m’a ému profondément, et parfois même touché là où les mots n’arrivent que rarement. Tu as su mêler l’humour à la tendresse, la simplicité au profond, la mémoire au vivant. Lettres de mon cabanon n’est pas une simple lecture. C’est une rencontre. Celle d’un homme avec sa mémoire, ses paysages, ses silences et ses eaux intérieures. Et à travers toi, j’ai vu ressurgir des vérités simples, universelles, celles qu’on oublie souvent, trop pris par le tumulte du monde. Chaque page m’a fait l’effet d’une confidence. Tu écris comme on parle à un ami au coin du feu : avec justesse, chaleur et pudeur. Et cela m’a profondément touché. Ce livre, c’est un peu de ton âme que tu as laissé couler entre les lignes. Et je l’ai reçue, Fraternellement. Merci pour cette offrande. Merci pour ta voix. Merci pour cette Provence intérieure que tu nous transmets comme on transmet une lumière rare. ",
    tags: ["Style", "Ambiance"],
  },
 
    
  {
    id: "crit-004",
    source: "Avis lecteur",
    auteur: "Compagnie Littéraire",
    date: "2025-10-16",
    extrait:
      "Une écriture vivante et picaresque, presque pagnolesque — on se balade dans des histoires de pêche, de « scoumougne » (la malchance façon Sud), et de camaraderie comme si on y était. Lecteurs qui connaissent la Provence parlent de vraie couleur locale et de vocabulaire marseillais qui pulse.  ",

    tags: ["Émotion", "Pagnolesque"],
  },
  {
    id: "crit-005",
    source: "Avis lecteur",
    auteur: "Martine & Francisco Prunera-Usach ( Prunette )",
    date: "2025-12-02",
    extrait:
      "Absolument génial ce livre !A « consommer » sans modération ! Ces histoires vraies et la façon « provençale »de les écrire par mon ami Richard , m’ont fait pleurer de rire 🤣(Une véritable thérapie pour le moral en baisse de certains ! ) ! Merci 🙏🏻 pour ce bouquin que j’ai absolument adoré ! un grand BRAVO à Richard Arnaud 👏J’attends, avec une grande impatience un autre bouquin, écrit par le talentueux Richard , que ce soit avec des récits vrais ou inventés , ce sera toujours un vrai régal pour le lecteur 👍",

    tags: ["Récits", "Humour"],
  },
  {
    id: "crit-005",
    source: "Avis lecteur",
    auteur: "Gatti G",
    date: "2025-09-21",
    extrait:
      "Merveilleuses histoires réelles, une amitié sincère, cette belle Provence racontait avec amour, avec gentillesse et douceur, avec du rire dans ses expressions très provençale. Un parfum d’eau de mer de Méditerranée, de poisson, de sel marin. L’auteur m’a offert tout ce que j’aime dans cette Provence. Un grand merci à l’auteur qui ma fait revivre 50ans de bonheur( avec Gaby).",

    tags: ["Bonheur", "Rire"],
  },
  {
    id: "crit-006",
    source: "Avis lecteur",
    auteur: "Michèle",
    date: "2025-04-10",
    extrait:
      "L’auteur a le don de captiver la lectrice que je suis avec ses anecdotes savoureusement rythmées où l’humour surgit avec finesse et naturel. Chaque scène est un éclat de vie et les rires qui en découlent sont aussi spontanés que précieux. La Provence que vous nous offrez n’est pas seulement un décor, sous votre plume elle prend vie, on s’y promène avec délice bercé par vos mots justes et sensoriels. Et que dire de cet ode à l’amitié indéfectible, ces liens sincères et durables nous rappelant l’importance de la fraternité et des bonheurs simples. L’espace d’un instant vous nous faites oublier les aléas du quotidien. Merci pour ce moment de soleil, votre écriture à la fois drôle tendre et lumineuse est une invitation au voyage et au bien-être.",

    tags: ["Humour", "Poétique"],
  },
  {
    id: "crit-007",
    source: "Avis lecteur",
    auteur: "Phanieflo",
    date: "2025-11-10",
    extrait:
      "De bien jolies histoires assez rocambolesques dignes de Laurel et Hardy qui se passent dans les Bouches du Rhône, entre Port Saint Louis du Rhône et la Côte Bleue. On suit Richard et Claude dans leurs aventures de pêche et parfois de cueillettes de champignons. Quel plaisir de retrouver les expressions marseillaises et les lieux que je connais si bien. C'est un livre chantant et drôle.",

    tags: ["Bonheur", "Emotion"],
  },
  {
    id: "crit-008",
    source: "Avis lecteur",
    auteur: "Jean Pierre Chetaille",
    date: "2026-01-10",
    extrait:
      "J'ai lu avec plaisir tes histoires issues de ton cabanon et je me suis régalé. J'ai l'avantage de bien te connaître et d'avoir en mémoire, à l'oreille, le son de ta voix. Ainsi j'ai eu l'impression que c'était toi-même qui me contait intimement tes nouvelles éditées ! Serais-tu l'homme qui murmurait à l'oreille des lecteurs ? La vraie traduction de l'américain du film célèbre aurait dû être 'L'homme qui chuchotait à l'oreille des chevaux'. Oui c'est ça, tu es le conteur qui, avec l'accent provençal, chuchote à l'oreille de ton lecteur... Bravo. ",

    tags: ["Provence", "Nouvelles"],
  },
];


